import { Controller } from "stimulus"
import { ChatSessionPreferenceService } from "../services/chat_session_preference_service"
export default class extends Controller {
  static targets = ["messageInput", "submitButton"]

  connect() {
    this.resetForm()
    this.scrollChatToBottom()
  }

  disconnect() {
  }

  scrollChatToBottom() {
    setTimeout(() => {
      const messagesContainer = document.querySelector('.chat-messages-container')
      this.scrollToBottom(messagesContainer)
    }, 10)
  }

  handleKeyDown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.element.querySelector('form').requestSubmit()
    }
  }

  submitMessage(event) {
    event.preventDefault()
    const messageContent = this.messageInputTarget.value.trim()
    if (!messageContent) return

    this.removeSettingsAlert()
    this.sendMessageToServer(messageContent)
  }

  sendMessageToServer(messageContent) {
    this.disableForm()

    const form = this.element.querySelector('form')
    const formData = this.prepareFormData(form, messageContent)

    fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: { "Accept": "application/json" }
    })
    .then(response => this.handleResponse(response))
    .then(data => this.handleSuccess(data))
    .catch(error => this.handleError(error))
  }

  prepareFormData(form, messageContent) {
    const formData = new FormData()
    formData.append('content', messageContent)

    const token = document.querySelector('meta[name="csrf-token"]').content
    formData.append('authenticity_token', token)

    return formData
  }

  handleResponse(response) {
    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.status}`)
    }
    return response.json()
  }

  handleSuccess(data) {
    this.resetForm()

    setTimeout(() => {
      this.scrollToBottom(document.querySelector('.chat-messages-container'))
    }, 100)
  }

  handleError(error) {
    console.error('Error sending message:', error)
    this.enableForm()
  }

  scrollToBottom(container) {
    if (container) {
      container.scrollTop = container.scrollHeight
    }
  }

  resetForm() {
    this.messageInputTarget.value = ''
    this.enableForm()
    this.messageInputTarget.focus()
    this.messageInputTarget.dispatchEvent(new Event('input'))
  }

  disableForm() {
    this.messageInputTarget.disabled = true
    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.classList.add('tw-opacity-50')
  }

  enableForm() {
    this.messageInputTarget.disabled = false
    this.submitButtonTarget.disabled = false
    this.submitButtonTarget.classList.remove('tw-opacity-50')
  }

  removeSettingsAlert() {
    const settingsAlert = document.getElementById('settings-alert')
    if (settingsAlert) {
      settingsAlert.remove()
      new ChatSessionPreferenceService().updatePreference({ notify: false })
    }
  }
}